import {
  Avatar,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@efexteam/components';
import { RoleIds } from '@efexteam/permission-manager';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import RoleSelector from '@pages/teamMember/editTeamMember/components/roleSelctor';
import { useTranslation } from 'react-i18next';
import AssignRoleStepStyles from './AssignRoleStep.style';
import useAssignRole from './hooks/useAssignRole';

const AssignRoleStep = ({
  canContinue,
}: {
  canContinue: (value: boolean) => void;
}) => {
  const { t } = useTranslation();
  const {
    email,
    userName,
    roleId,
    setRoleId,
    setShowAuthorizationTerms,
    showAuthorizationTerms,
    setAuthorizationTerms,
  } = useAssignRole({ canContinue });

  return (
    <Stack className={AssignRoleStepStyles.wrapper}>
      <Typography variant="h4">{t('crtMmbStep2')}</Typography>
      <Box className={AssignRoleStepStyles.memberInfo}>
        <Box display="flex" alignItems="center" gap={2}>
          <Avatar
            showLabel
            username={userName}
            secondLine={email?.label}
            size="md"
          />
        </Box>
      </Box>
      <RoleSelector
        roleId={roleId}
        setRoleId={setRoleId}
        selectorLabel={t('selectRole') as string}
      />

      {roleId === RoleIds.PROMOTER && (
        <FormControlLabel
          control={
            <Checkbox
              onChange={(e) => {
                canContinue(e.target.checked);
                setAuthorizationTerms(e.target.checked);
              }}
              className={AssignRoleStepStyles.authorizationTermsText}
            />
          }
          label={
            <Typography
              variant="body1"
              className={AssignRoleStepStyles.authorizationTermsText}
            >
              {t('authorizationTerms')}{' '}
              <span
                onClick={() => setShowAuthorizationTerms(true)}
                className={AssignRoleStepStyles.authorizationTermsLink}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setShowAuthorizationTerms(true);
                  }
                }}
              >
                {t('authorizationTermsLink')}
              </span>
            </Typography>
          }
        />
      )}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={showAuthorizationTerms}
        onClose={() => setShowAuthorizationTerms(false)}
      >
        <DialogTitle
          showCloseButton
          onClick={() => setShowAuthorizationTerms(false)}
        />
        <DialogContent>
          <Box className={AssignRoleStepStyles.authorizationTermsModal}>
            <Typography variant="h4">{t('authorizationTermsModal')}</Typography>
            <Typography>
              {t('authorizationTermsText', { promoterName: userName || '' })}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Stack>
  );
};

export default AssignRoleStep;
